document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".collection-coverflow").forEach(section => {

    const slider = section.querySelector(".cf-slider");
    const cards = [...slider.querySelectorAll(".cf-card")];

    if (cards.length < 2) return;

    const prevBtn = section.querySelector(".cf-arrow.prev");
    const nextBtn = section.querySelector(".cf-arrow.next");

    const sectionId = section.id.replace("coverflow-", "");
    const settings = window.CoverflowSettings[sectionId];

    let current = 0;
    let autoplay;

    function normalize(i) {
      return (i + cards.length) % cards.length;
    }

    function render() {

      cards.forEach(card => {
        card.classList.remove(
          "active",
          "left1",
          "left2",
          "right1",
          "right2",
          "hide"
        );
      });

      const active = normalize(current);
      const left1 = normalize(current - 1);
      const left2 = normalize(current - 2);
      const right1 = normalize(current + 1);
      const right2 = normalize(current + 2);

      cards.forEach(card => card.classList.add("hide"));

      cards[active].classList.remove("hide");
      cards[left1].classList.remove("hide");
      cards[left2].classList.remove("hide");
      cards[right1].classList.remove("hide");
      cards[right2].classList.remove("hide");

      cards[active].classList.add("active");
      cards[left1].classList.add("left1");
      cards[left2].classList.add("left2");
      cards[right1].classList.add("right1");
      cards[right2].classList.add("right2");

    }

    function next() {

      current++;

      if (settings.loop) {
        current = normalize(current);
      } else {
        current = Math.min(current, cards.length - 1);
      }

      render();

    }

    function prev() {

      current--;

      if (settings.loop) {
        current = normalize(current);
      } else {
        current = Math.max(current, 0);
      }

      render();

    }

    nextBtn.addEventListener("click", () => {

      stop();
      next();
      start();

    });

    prevBtn.addEventListener("click", () => {

      stop();
      prev();
      start();

    });

    function start() {

      if (!settings.autoplay) return;

      autoplay = setInterval(() => {

        next();

      }, settings.interval);

    }

    function stop() {

      clearInterval(autoplay);

    }

    section.addEventListener("mouseenter", stop);
    section.addEventListener("mouseleave", start);

    // Swipe

    let startX = 0;

    section.addEventListener("touchstart", e => {

      startX = e.touches[0].clientX;

    });

    section.addEventListener("touchend", e => {

      let endX = e.changedTouches[0].clientX;

      if (startX - endX > 50) {

        stop();
        next();
        start();

      }

      if (endX - startX > 50) {

        stop();
        prev();
        start();

      }

    });

    render();
    start();

  });

});